import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {MessageService} from 'primeng/api';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../cc-base.component';
import {FormFieldGroupConfig} from '../../../model/api/form-field-group-config';
import {FormFieldConfig} from '../../../model/api/form-field-config';
import {CcSubFormBaseComponent} from "../../form-dialog/form/cc-sub-form-base.component";
import {CcSubDetailBaseComponent} from "./cc-sub-detail-base.component";

@Component({
  selector: 'app-cc-detail[formConfig]',
  templateUrl: './cc-detail.component.html',
  styleUrls: ['./cc-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ]
})
export class CcDetailComponent<T = any> extends CcBaseComponent {

  FieldTypes = FormFieldConfig.TYPE;

  fieldValueMap = {};

  @Input()
  formConfig: FormFieldGroupConfig[];

  @Input()
  formRecord: any;

  @Input()
  transPartKey: String;

  @ViewChildren('ccSubDetail')
  subDetailComponents: QueryList<CcSubDetailBaseComponent>;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {
    this.initConfigs();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.initConfigs();
    });
  }

  protected getFields(fieldResult) {
    if (fieldResult.success) {
      return fieldResult.records;
    } else {
      this.errorMessage(fieldResult.message);
      return undefined;
    }
  }

  public reloadFieldValueMap(): void {
    // console.log("------> reloadFieldValueMap");
    // setTimeout(() => {
    if (this.formConfig && this.formRecord) {
      this.formConfig.forEach((groupConf, groupIndex) => {
        if (groupConf.hidden)
          this.fieldValueMap['hiddenGroup-' + groupIndex] = groupConf.hidden(this.formRecord);
        groupConf.fields.forEach((fieldConfig, fieldIndex) => {
          if (fieldConfig.hidden)
            this.fieldValueMap['hiddenField-' + groupIndex + '_' + fieldIndex] = fieldConfig.hidden(this.formRecord);

          if (fieldConfig) {
            if (fieldConfig.format && fieldConfig.format.includes('#'))
              fieldConfig.format = '1.0-7';
            if (fieldConfig.mapValue)
              this.fieldValueMap['mapValue-' + groupIndex + '_' + fieldIndex] = fieldConfig.mapValue(this.formRecord);
            if (fieldConfig.options) {
              this.fieldValueMap['options-' + groupIndex + '_' + fieldIndex] = fieldConfig.options(this.formRecord);
            }
            if (fieldConfig.style) {
              this.fieldValueMap['style-' + groupIndex + '_' + fieldIndex] = fieldConfig.style(this.formRecord);
            }
            if (fieldConfig.hidden)
              this.fieldValueMap['hiddenField-' + groupIndex + '_' + fieldIndex] = fieldConfig.hidden(this.formRecord);


          }
        });
      });
      if (this.subDetailComponents) {
        this.subDetailComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
      }
      this.markForCheck();
    }
    // -- fieldConfig.icon()
    // fieldConfig.icon(option.id)
    // formRecord[fieldConfig.field]?(fieldConfig.icon(formRecord[fieldConfig.field])):''
    // fieldConfig.iconValue()
    // fieldConfig.iconValue ? fieldConfig.iconValue(option.id) : ''
    // fieldConfig.iconValue ? fieldConfig.iconValue(formRecord[fieldConfig.field]) : ''
    // (fieldConfig.disabled?fieldConfig.disabled(formRecord):false)
    // fieldConfig.options()
    // fieldConfig.findOptionText ? fieldConfig.findOptionText(formRecord[fieldConfig.field])
    //  -- fieldGroup.hidden?fieldGroup.hidden(formRecord):false
    // fieldGroup.hidden?fieldGroup.hidden(formRecord):(fieldConfig.hidden?fieldConfig.hidden(formRecord):false)
    // });
    this.cdref.detectChanges();
  }
}
